import {z} from 'zod';

import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {baseCardSchema} from './baseSchemas';
import {clinchEnums} from '@cl/shared';
import {CLEnumKeys, CLEnumType} from 'common/src/modules/enums/enums.types';
import {ProductSelectionStrategyType} from 'common/src/modules/productSelectionStrategies/productSelectionStrategies.types';

const {loadedEnumsSubject} = clinchEnums;

export const productCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.PRODUCTS),
  feedId: z.number().nullable().describe('The feed ID, can be left empty'),
  topItemsListId: z.number().nullable().describe('The top items list ID, can be left empty'),
  productSetId: z.number().nullable().describe('The product set ID, can be left empty'),
  categoryTopItemsListId: z.number().nullable().describe('The category top items list ID, can be left empty'),
  productsSelectionStrategy: z
    .nativeEnum(ProductSelectionStrategyType)
    .describe(
      `The product selection strategy ID, optional values: ${loadedEnumsSubject.data[CLEnumType.CampaignPage]?.[CLEnumKeys.CampaignPage.CampaignContentType]?.enumsForSelector.map((strategy) => `ID: ${strategy.value} Name: ${strategy.name} Description: ${strategy.description}`).join(', ')}`,
    ),
  productIds: z
    .array(z.string())
    .describe('The product IDs, for specific product selection strategy'),
  conditions: z.array(
    z.object({
      feedColumnSignalKey: z.string(),
      operator: z
        .number()
        .describe(
          `match the user request to one of the following options: ${loadedEnumsSubject.data[CLEnumType.CampaignPage]?.[CLEnumKeys.CampaignPage.ProductSelectionOperator]?.enumsForSelector.map((enumValue) => `${enumValue.name}: ${enumValue.value}`).join(', ')}`,
        ),
      signalKey: z.string(),
      feedKey: z.number(),
    }),
  ),
});
